import React, { useState } from 'react';
import { Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { ProductComparison } from '@/components/ProductComparison';
import { RatgeberSection } from '@/components/RatgeberSection';
import { FAQAccordion } from '@/components/FAQAccordion';
import { Footer } from '@/components/Footer';
import { CookieBanner } from '@/components/CookieBanner';
import { MobileFloatingCTA } from '@/components/MobileFloatingCTA';
import { products } from '@/data/products';

export const HomePage = () => {
    const [isCookieSettingsOpen, setIsCookieSettingsOpen] = useState(false);

    const testsiegerProduct = products.find((p) => p.rank === 1) || products[0];

    const handleOpenCookieSettings = () => {
        // Reset consent in localStorage to show banner again
        localStorage.removeItem('cookie_consent');
        setIsCookieSettingsOpen(true);
    };

    const handleCloseCookieSettings = () => {
        setIsCookieSettingsOpen(false);
    };

    return (
        <div className="min-h-screen bg-background">
            {/* Header Navigation */}
            <Header />

            {/* Main Content */}
            <main className="pb-28 md:pb-0">
                {/* Hero Section */}
                <Hero />

                {/* Testsieger Anchor Point */}
                <div id="testsieger" className="scroll-mt-20" />

                {/* Product Comparison Section */}
                <ProductComparison />

                {/* Ratgeber Section */}
                <RatgeberSection />

                {/* FAQ Section */}
                <FAQAccordion />
            </main>

            {/* Footer */}
            <Footer onOpenCookieSettings={handleOpenCookieSettings} />

            {/* Mobile Floating CTA (Testsieger) */}
            <MobileFloatingCTA
                affiliateLinkTemplate={testsiegerProduct?.affiliateLink}
                productName={testsiegerProduct?.name}
                badge={testsiegerProduct?.badge}
                price={testsiegerProduct?.price}
            />

            {/* Cookie Consent Banner */}
            <CookieBanner
                isOpen={isCookieSettingsOpen}
                onClose={handleCloseCookieSettings}
            />
        </div>
    );
};

